import React, { ReactElement } from "react";

// others
import Button from "../../../molecules/Button";
import { useNavigate } from "react-router-dom";
import { deleteBooking } from "../ducks/actions";
import { useDispatch, useSelector } from "react-redux";
import { BackIcon, NextIcon } from "../../../../assets/svg";
import { Row, Col, Space, message, Tag } from "antd";
import { PopupConfirm } from "../../../atoms/Popup";
import { SettingOutlined } from "@ant-design/icons";

type TopButton = {
  label: string;
  action: (obj: object) => void;
};
interface IProps {
  label?: string;
  children: ReactElement;
  leftBtnLabel?: string;
  rightBtnLabel?: string;
  handleBack?: () => void;
  parentState?: (obj: object) => void;
  handleNext?: (data: any, type: string) => void;
  handleSaveDraft?: () => void;
  handleDone?: (data: any, type: string) => void;
  topButton?: TopButton;
  topButtons?: { label: string; action: () => void } | { label: string; action: () => void }[];
  statusHeader?: ReactElement;
  isBlocked?: boolean;
  btnEnable?: boolean;
  torActions?: TopButton;
  handeLeaseConfig?: () => void;
}

const index = (props: IProps) => {
  // hooks initialization
  const navigate = useNavigate();
  const dispatch: any = useDispatch();

  // redux states
  const { bookingDetails } = useSelector((state: any) => state.newBooking);

  // variables
  const isBooking = Object.keys(bookingDetails || {}).length > 0;

  const handleDiscard = async () => {
    PopupConfirm({
      title: `Do you really want to discard your booking? You’ll lose any changes you’ve made?`,
      onOk: async () => {
        props.parentState({ load: true });
        const response = await dispatch(deleteBooking(bookingDetails.leaseId));
        if (response?.status === 200) {
          props.parentState({ load: false });
          navigate("/bookings");
          message.success("Your booking was successfully deleted");
        } else {
          props.parentState({ load: false });
          message.error(response.data.error || response.data.message);
        }
      },
      okText: "Yes",
    });
  };

  const normalizedTopButtons = Array.isArray(props?.topButtons)
    ? props?.topButtons
    : props?.topButtons
    ? [props?.topButtons]
    : [];

  return (
    <Col span={24} className="cc-main">
      {props?.statusHeader && (
        <Col span={24}>
          <Tag className="fm-status-header" color="cyan">
            <div>{props.statusHeader}</div>
          </Tag>
        </Col>
      )}
      <Col span={24} className="ft-label-container">
        <Row>
          <Row className="cc-fotter_left">
            <Col sm={5}>
              <p className="ft-main-label">{props.label}</p>
            </Col>
            {props?.handeLeaseConfig && (
              <Col sm={4}>
                <Button
                  label={"Configuration"}
                  onClick={props.handeLeaseConfig}
                  className="cc-fotter_back-button"
                  icon={<SettingOutlined width="16px" height="16px" />}
                ></Button>
              </Col>
            )}
          </Row>
          <Row className="cc-fotter_right">
            <div style={{ display: "flex", justifyContent: "right" }}>
              {normalizedTopButtons.map((button, index) => (
                <Col key={index}>
                  <Button
                    style={{ marginLeft: "10px" }}
                    label={button.label || "Save"}
                    className="cc-fotter_next-button"
                    onClick={button.action}
                  />
                </Col>
              ))}

              {props?.torActions ? (
                <Col>
                  <Button
                    style={{ marginLeft: "10px" }}
                    label={bookingDetails?.torRules?.length > 0 ? "Edit TOR Rules" : props.torActions.label || "Add"}
                    className="cc-fotter_next-button"
                    onClick={() => (props.torActions as TopButton).action({})}
                  />
                </Col>
              ) : null}
            </div>
            {/* <Row className="cc-fotter_right" style={{ width: "900px" }} gutter={12}>
              
              {props?.torActions ? (
                <Col>
                  <Button
                    style={{ marginLeft: "3px" }}
                    label={bookingDetails?.torRules?.length > 0 ? "Edit Tor Rules" : props.torActions.label || "Add"}
                    className="cc-fotter_next-button"
                    onClick={() => (props.torActions as TopButton).action({})}
                  />
                </Col>
              ) : null}
            </Row> */}
          </Row>
        </Row>
      </Col>

      {props.label && <Col span={24} className="ft-divider" />}

      {props.children}

      {(props.leftBtnLabel || props.rightBtnLabel) && (
        <Row className="cc-fotter-container">
          <Row className="cc-fotter_left">
            {props.leftBtnLabel && (
              <Button
                label={props.leftBtnLabel}
                onClick={props.handleBack}
                className="cc-fotter_back-button"
                icon={<BackIcon width="16px" height="16px" />}
              />
            )}
          </Row>
          <Row className="cc-fotter_right">
            {props.rightBtnLabel && (
              <Space size="middle">
                {isBooking && <Button label="Discard" onClick={handleDiscard} className="bf-discard-button" />}

                {props?.handleSaveDraft ? (
                  <Button label="Save Draft" onClick={props?.handleSaveDraft} className="bf-save-draft-button" />
                ) : (
                  <Button type="submit" label="Save Draft" className="bf-save-draft-button" />
                )}

                {props?.handleNext && (
                  <Button
                    disabled={props?.isBlocked}
                    label={props.rightBtnLabel}
                    className="cc-fotter_next-button"
                    icon={<NextIcon width="16px" height="16px" />}
                    onClick={() => props?.handleNext(undefined, "next")}
                  />
                )}

                {props?.handleDone && (
                  <Button
                    label={props.rightBtnLabel}
                    className="cc-fotter_next-button"
                    onClick={() => props?.handleDone(undefined, "done")}
                  />
                )}
              </Space>
            )}
          </Row>
        </Row>
      )}
    </Col>
  );
};

export default index;
